import React from 'react';
import PropTypes from 'prop-types';
import { ColorBlock, CategoryAllocation } from './styles';
import { Layout } from '@hub-mono/ui';

export const SimpleCategoryTemplateItem = props => {
    const { item } = props;

    return item?.name ? (
        <Layout>
            <ColorBlock color={item.gridColor} />
            <span>{item.name}</span>
        </Layout>
    ) : null;
};

SimpleCategoryTemplateItem.propTypes = {
    item: PropTypes.object.isRequired,
};

const CategoryTemplateItem = props => {
    const { item } = props;

    return item?.name ? (
        <Layout gap="--Spacing-100" pl={9} pt={5} pr={5} pb={5}>
            <ColorBlock color={item.gridColor} />
            <span>{item.name}</span>
            {item?.allocationText && <CategoryAllocation>{item.allocationText}</CategoryAllocation>}
        </Layout>
    ) : null;
};

CategoryTemplateItem.propTypes = {
    item: PropTypes.object.isRequired,
};

export default CategoryTemplateItem;
